import { useState, useEffect, useRef, useCallback } from 'react'

export function useTimer(initialSeconds = 0) {
  const [seconds, setSeconds] = useState(initialSeconds)
  const [isRunning, setIsRunning] = useState(false)
  const intervalRef = useRef(null)

  const start = useCallback(() => {
    if (!isRunning) setIsRunning(true)
  }, [isRunning])

  const pause = useCallback(() => {
    setIsRunning(false)
  }, [])

  const reset = useCallback(() => {
    setIsRunning(false)
    setSeconds(0)
  }, [])

  useEffect(() => {
    if (isRunning) {
      intervalRef.current = setInterval(() => {
        setSeconds(s => s + 1)
      }, 1000)
    } else if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current)
    }
  }, [isRunning])

  return { seconds, isRunning, start, pause, reset }
}

export function useTodayBlocks(userId, date) {
  const [blocks, setBlocks] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchBlocks = useCallback(async () => {
    if (!userId) return
    setLoading(true)
    const { supabase } = await import('../lib/supabase')
    const { data, error } = await supabase
      .from('daily_blocks')
      .select('*')
      .eq('user_id', userId)
      .eq('date', date)
      .order('block_name')

    if (!error) setBlocks(data || [])
    setLoading(false)
  }, [userId, date])

  useEffect(() => {
    fetchBlocks()
  }, [fetchBlocks])

  return { blocks, loading, refetch: fetchBlocks }
}
